import { postMessageToParent } from 'utils';

const localStorage = (() => {
    let hasStoragePermissions = false;
    try {
        window.localStorage.getItem('');
        hasStoragePermissions = true;
    } catch (error) {
        hasStoragePermissions = false;
    }

    const getItem = (key: string) =>
        hasStoragePermissions ? window.localStorage.getItem(key) : '';
    const setItem = (key: string, value: any) =>
        hasStoragePermissions && window.localStorage.setItem(key, value);
    const removeItem = (key: string) =>
        hasStoragePermissions && window.localStorage.removeItem(key);

    return {
        getItem,
        setItem,
        removeItem,
    };
})();

export const persistanceManager = (contactFlowId: string, globalRestoreSession = false) => {
    const cacheKey = `smartagent_connection_contactid/${contactFlowId}`;
    const attachmentCacheKey = `smartagent_signed_attachment_ids/${contactFlowId}`;

    const getGlobalPageStatus = async () =>
        !!(await getPersistenceItem(
            'smartagent_connection/global',
            'get-smartagent-global-page-status',
            'recieve-smartagent-global-page-status'
        ));

    const getPersistanceContactId = async () =>
        await getPersistenceItem(
            cacheKey,
            'get-smartagent-persistance-contactId',
            'recieve-smartagent-persistance-contactId'
        );

    const getPersistenceItem = (key: string, getType: string, receiveType: string) => {
        return new Promise<string | null>(res => {
            const timeout = setTimeout(() => res(localStorage.getItem(key)), 2000);

            window.addEventListener('message', (message: MessageEvent) => {
                if (message.data.type === receiveType) {
                    clearTimeout(timeout);
                    res(message.data.content ?? localStorage.getItem(key));
                }
            });

            postMessageToParent(getType, cacheKey);
        });
    };

    const setPersistanceContactId = (contactId: string) => {
        console.log('posting persistence');
        postMessageToParent('set-smartagent-persistance-contactId', {
            cacheKey: cacheKey,
            contactId: contactId,
            globalRestoreSession,
        });

        localStorage.setItem(cacheKey, contactId);
    };

    const setPersistenceAttachmentIds = (contactId: string) => {
        localStorage.setItem(attachmentCacheKey, `{"${contactId}":[]}`);
    };

    const deletePersistanceContactId = () => {
        postMessageToParent('delete-smartagent-persistance-item', 'smartagent_connection/global');
        postMessageToParent('delete-smartagent-persistance-item', cacheKey);
        localStorage.removeItem(attachmentCacheKey);
        localStorage.removeItem(cacheKey);
    };

    return {
        getPersistanceContactId,
        setPersistanceContactId,
        deletePersistanceContactId,
        getGlobalPageStatus,
        cacheKey,
        setPersistenceAttachmentIds,
    };
};

